import React, { memo } from 'react'

import {
  DEFAULT_RESUBMIT_TIME,
  useSubmitAction
} from 'src/libs/qb-brand-web-components'

const CustomForm = ({
  children,
  onFormSubmit,
  resubmitTime = DEFAULT_RESUBMIT_TIME
}) => {
  const handleOnSubmit = useSubmitAction(resubmitTime, (e) => {
    if (onFormSubmit) {
      onFormSubmit(e)
    }
  })
  return (
    <form onSubmit={handleOnSubmit} noValidate>
      {children}
    </form>
  )
}

export default memo(CustomForm)
